import ReactPlayer from 'react-player/youtube';

interface VideProps {
    className?: string;
    attrs?: any;
    style?: any;
}

const defaultProps: VideProps = {
    // url: "https://www.youtube.com/watch?v=9vwaD9cHLNw"
};

const YoutubeVideo = ({ className, style, attrs }: VideProps) => {
    const css: any = ["covr-video"];

    if (className) {
        css.push(className);
    }

    return (
        <div className={css.join(' ')} style={style}>
            <ReactPlayer
                className="react-player"
                url={attrs.url}
                width="100%"
                height="100%"
            />
        </div>
    );
};

YoutubeVideo.defaultProps = defaultProps;

export default YoutubeVideo;
